<template lang="html">
  <div class="quotation-layout">
    <SchedulingBreadcrumb />
    <div class="forms-padding">
      <b-row class="row-eq-height">
        <b-col col lg="3" md="3" sm="12" cols="12" class="profile-menu-card">
            <ProfileMenu />
        </b-col>
        <b-col col lg="9" md="9" sm="12" cols="12" class="forms-quoation-card mb-100">
          <SchedulingForm />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import SchedulingBreadcrumb from "../components/Scheduling/SchedulingBreadcrumb.vue";
import ProfileMenu from "../components/Profile/profileMenu.vue";
import SchedulingForm from "../components/Scheduling/SchedulingForm.vue";

export default {
  name: "Quotation",
  components: {
    SchedulingBreadcrumb,
    ProfileMenu,
    SchedulingForm,
  },
  methods: {},
};
</script>
<style lang="css">
.quotation-layout {
  padding-top: 25vh !important;
}
@media only screen and (max-width: 1077px) {
 .profile-menu-card{
     padding: 0px!important;
  }
  .forms-quoation-card{
      padding: 0px!important;
  }
}